import React, { useState, useEffect } from "react";
import { Program } from "../../types/program";
import apiClient from "../../services/api";
import Sidebar from "./Sidebar";
import ContactSidebar from "./ContactSidebar";

interface SmartSidebarProps {
  program?: Program;
  programId?: string;
  slug?: string;
}

const SmartSidebar: React.FC<SmartSidebarProps> = ({ program: externalProgram, programId, slug }) => {
  const [fetchedProgram, setFetchedProgram] = useState<Program | null>(null);
  const [loading, setLoading] = useState(!!slug && !externalProgram);

  useEffect(() => {
    if (!slug || externalProgram) return;
    const fetchProgram = async () => {
      try {
        const response = await apiClient.getProgram(slug);
        if (response.success) {
          setFetchedProgram(response.data.program || response.data);
        }
      } catch (err) {
        console.error("Error fetching program:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProgram();
  }, [slug, externalProgram]);

  const program = externalProgram || fetchedProgram;

  if (loading || !program) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-8 sticky top-8 animate-pulse">
        <div className="h-10 bg-gray-200 rounded mb-4"></div>
        <div className="h-4 bg-gray-200 rounded mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-6"></div>
        <div className="h-12 bg-gray-200 rounded-xl"></div>
      </div>
    );
  }

  if (program.is_active) {
    return <Sidebar program={program} programId={programId || slug} />;
  }

  return <ContactSidebar programTitle={program.title} />;
};

export default SmartSidebar;
